import { Component } from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'app-land',
  imports: [
    RouterOutlet
  ],
  templateUrl: './land.component.html',
  styleUrl: './land.component.scss',
})
export class LandComponent {

}
